import type {Dispatch, FC, SetStateAction} from 'react'
import {useEffect, useRef} from 'react'
import {ModalDefault} from '../../ui'

interface Props {
    text?: string
    id?: number
    setStates?: Dispatch<SetStateAction<number>>
    handleClick?: (e: any) => void
}

const ModalDelete: FC<Props> = ({text, id, setStates, handleClick}) => {
  useEffect(() => {
    document.getElementById('delete-modal')?.addEventListener('hidden.bs.modal', () => {
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <ModalDefault id='delete-modal' title='Delete' hides={['footer']}> 
        <div className='modal-body'>
            <h3>{text} ?</h3>
        </div>    
        <div className='d-flex justify-content-end gap-4'>
          <button 
            type='button' 
            id='close-modal' 
            className='btn btn-light' 
            data-bs-dismiss='modal'
            onClick={() => setStates!(0)}>
            Cancel
          </button>
          <button  
            type='button' 
            id='close-modal' 
            data-bs-dismiss='modal' 
            className='btn btn-danger' 
            onClick={() =>{ 
              handleClick!(id)
              setStates!(0)
            }} >
            Delete
          </button>
        </div>
    </ModalDefault>
  )
}

export default ModalDelete
